// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Y2zve","inner":"Footer_inner__1OoId"};